import type { State } from '../../typings'

export const closeActivityTypeFormProducer = (state: State) => ({
  ...state,
  isOpen: false,
  current: undefined,
})
